module.exports = __webpack_public_path__ + "static/media/sidebar-logo.d6e27b4a.svg";